import _ from "lodash";
import { queryWaterProviderWithDocs } from "./api";
import { PROVIDER_FIELDS, QUERY_URL_AND } from "./constants";
import { WaterProvider } from "./types";

export const fetchProviderByKeyword = async (keyword: string): Promise<WaterProvider[]> => {
    if (!keyword || keyword.toString().trim().length < 2) return [];
    const _keyword = (keyword ?? "")?.trim();

    const words = _keyword
        ?.trim()
        ?.split(" ")
        ?.filter(word => word != null && word.trim() !== "");
    const wordCount = words?.length;

    const query = !wordCount
        ? ""
        : wordCount <= 1
        ? `(tm_X3b_en_name:${_keyword}) OR (tm_X3b_en_name:${_keyword}*)`
        : _.join(
              words.map(word => `"${word}"`),
              " + "
          );

    const solrQuery = _.join(
        [
            // `q=(tm_X3b_en_name:${keyword.toString().trim().toLowerCase()}*) OR (tm_X3b_en_name:${keyword
            //     .toString()
            //     .trim()
            //     .toLowerCase()})`,

            `q=${query}`,
            `q.op=OR`,
            !wordCount || wordCount <= 1 ? null : `defType=dismax`,
            !wordCount || wordCount <= 1 ? null : `qf=tm_X3b_en_name`,
            "rows=10",
            `fl=${PROVIDER_FIELDS}`
        ].filter(d => d != null),
        QUERY_URL_AND
    );

    return queryWaterProviderWithDocs(solrQuery);
};
